var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { XBox } from '../box/XBox';
import clsx from 'clsx';
export function XGrid(_a) {
    var _b;
    var className = _a.className, minMax = _a.minMax, rest = __rest(_a, ["className", "minMax"]);
    rest.gap = (_b = rest.gap) !== null && _b !== void 0 ? _b : 4;
    var style = {};
    if (minMax) {
        style.gridTemplateColumns = "repeat(auto-fit, minmax(" + minMax + "px, 1fr))";
    }
    return React.createElement(XBox, __assign({ className: clsx('XGrid', className), style: style }, rest));
}
